"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Pin;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Pin(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "pin"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M85.775,13.923c-5.8-5.732-11.54-8.639-17.071-8.64h0A13.234,13.234,0,0,0,59.753,8.5c-4.438,3.92-4.3,9.527-3,13.771-3.049,2.706-8.938,7.424-14.506,11.7a30.827,30.827,0,0,0-7.5-.987c-6.748,0-12.044,2.628-15.315,7.6-6.514,9.9,2.628,22.639,7.7,28.472L8.232,87.949a2.5,2.5,0,1,0,3.536,3.535L30.626,72.625c3.984,3.541,12.858,10.458,21.391,10.458A13.723,13.723,0,0,0,59.7,80.855c8.582-5.646,8.465-16,6.64-22.849,4.277-5.57,8.992-11.454,11.69-14.491a17.356,17.356,0,0,0,5.007.8,11.307,11.307,0,0,0,8.718-3.753c3.535-3.721,6.785-13.73-5.393-26.054ZM82.62,17.839C94.984,30.2,88.077,37.171,88.077,37.171a6.389,6.389,0,0,1-5.042,2.144,14.7,14.7,0,0,1-6.212-1.665c-3.232,2.514-16.042,19.394-16.042,19.394s5.268,13.648-3.831,19.634a8.789,8.789,0,0,1-4.933,1.405c-8.151,0-17.883-8.972-19.31-10.331l0,0-.087-.089-.089-.086,0,0C30.88,65.842,18,51.856,23.605,43.333c2.774-4.217,7.193-5.348,11.137-5.348a26.453,26.453,0,0,1,8.5,1.517s16.88-12.81,19.394-16.042c0,0-4.047-7.328.479-11.253A8.253,8.253,0,0,1,68.7,10.283c3.267,0,7.9,1.542,13.742,7.38Z"
  }))));
}